import apiClient from "services/apiClient";

async function editType(id: any, data: any) {
  const url = `/admin/types/${id}`;
  const res = await apiClient.put(url, data);
  return res.data;
}

export default editType;
